import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../store";

const BalanceItem = ({
  label,
  value,
  color,
  icon,
}: {
  label: string;
  value: number;
  color: string;
  icon: React.ReactNode;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 2,
        borderRadius: "16px",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Typography
        variant="h6"
        sx={{ color, fontWeight: 600, display: "flex", alignItems: "center", gap: 1 }}
      >
        {icon} {label}
      </Typography>
      <Typography variant="h6" sx={{ color }}>
        {value?.toLocaleString?.() ?? "-"}
      </Typography>
    </Box>
  );
};

export const Balance = () => {
  const dispatch = useDispatch<any>();
  const userModule = useSelector((state: AppState) => state.userModule);
  const loginInfo = userModule.loginInfo;
  const gameStatus = userModule.gameStatus;

  return (
      <Box
        sx={{
          minHeight: "calc(100vh - 80px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
        p: { xs: 2, sm: 4, md: 8 },
        borderRadius: "32px",
        background: "rgba(20, 16, 40, 0.95)",
        boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
        minWidth: { xs: "90vw", sm: "400px", md: "500px" },
        maxWidth: "95vw",
        textAlign: "center",
          }}
        >
          <Typography
        variant="h4"
        sx={{
          color: "#b388ff",
          fontWeight: 700,
          mb: 2,
          letterSpacing: 2,
          textShadow: "0 2px 8px #0008",
        }}
          >
        Your Balance
          </Typography>
            <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              mt: 3,
            }}
            >
            <BalanceItem
              label="WAX"
              value={loginInfo?.balance?.wax_balance}
              color="#1e90ff"
              icon={<img src="/images/token_wax.png" alt="WAX" style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
            />
            <BalanceItem
              label="GRASS"
              value={loginInfo?.balance?.game_grass}
              color="#43ea7f"
              icon={<img src="/images/token_grass.png" alt="GRASS" style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
            />
            <BalanceItem
              label="ANTLERS"
              value={loginInfo?.balance?.game_antlers}
              color="#b388ff"
              icon={<img src="/images/token_antlers.png" alt="ANTLERS" style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
            />
            <BalanceItem
              label="GOLD"
              value={loginInfo?.balance?.game_gold}
              color="#ffa500"
              icon={<img src="/images/token_gold.png" alt="GOLD" style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
            />
            <BalanceItem
              label="XP"
              value={loginInfo?.balance?.game_xp}
              color="#ff69b4"
              icon={<img src="/images/xp.webp" alt="XP" style={{ width: 24, height: 24, verticalAlign: "middle" }} />}
            />
            </Box>
        </Box>
      </Box>
  );
};
